/**
 * Build Information
 * Provides app version and environment information for diagnostics
 *
 * TODO: In CI/CD, inject real version and env via webpack DefinePlugin or similar
 * Example: __OPTLAB_VERSION__ and __OPTLAB_ENV__ can be set at build time
 */

// Read version from package.json (will be bundled at build time)
// For now, use a constant; CI should inject actual version
const PACKAGE_VERSION = "0.0.1"; // TODO: Read from package.json or inject at build time

// Read env from compile-time constant (injected by webpack DefinePlugin)
function getEnv(): string {
  // @ts-ignore - __OPTLAB_ENV__ is injected by webpack
  if (typeof __OPTLAB_ENV__ !== "undefined") {
    // @ts-ignore
    return __OPTLAB_ENV__;
  }
  // Fallback to runtime global if available
  if (typeof globalThis !== "undefined" && (globalThis as any).__OPTLAB_ENV__) {
    return (globalThis as any).__OPTLAB_ENV__;
  }
  return "dev";
}

export const BUILD_INFO = {
  version: PACKAGE_VERSION,
  env: getEnv(),
} as const;
